export function buildPeopleSyncMenuItems(state) {
    var isPeopleSyncWorkforce    = state.isPeopleSyncWorkforce;
    var isPeopleSyncTimekeeping  = state.isPeopleSyncTimekeeping;
    var isPeopleSyncSelfService  = state.isPeopleSyncSelfService;
    var setIsPeopleSyncWorkforce   = state.setIsPeopleSyncWorkforce;
    var setIsPeopleSyncTimekeeping = state.setIsPeopleSyncTimekeeping;
    var setIsPeopleSyncSelfService = state.setIsPeopleSyncSelfService;
    var setIscurrentState          = state.setIscurrentState;

    return [
        {
            id: "peoplesync",
            label: "PeopleSync",
            icon: "ri-team-fill",
            link: "/#",
            subItems: [
                {
                    id: "peoplesync-dashboard", label: "Dashboard", icon: "ri-bar-chart-2-fill",
                    link: "/peoplesync/dashboards/main", parentId: "peoplesync", permissionTypeId: [],
                },
                {
                    id: "peoplesync-employees", label: "Employees", icon: "ri-contacts-fill",
                    link: "/peoplesync/employees", parentId: "peoplesync", permissionTypeId: [],
                },
                {
                    id: "peoplesync-plantilla", label: "Plantillas", icon: "ri-file-list-2-fill",
                    link: "/peoplesync/plantilla", parentId: "peoplesync", permissionTypeId: [],
                },
                {
                    id: "peoplesync-applicants", label: "Applicant Pool", icon: "ri-user-search-fill",
                    link: "/peoplesync/applicants", parentId: "peoplesync", permissionTypeId: [],
                },
                {
                    id: "peoplesync-self-service", label: "My Self-Service", icon: "ri-user-smile-fill",
                    link: "/#", parentId: "peoplesync", isChildItem: true,
                    stateVariables: isPeopleSyncSelfService,
                    click: function (e) { e.preventDefault(); setIsPeopleSyncSelfService(!isPeopleSyncSelfService); setIscurrentState("PeopleSyncSelfService"); },
                    childItems: [
                        { id: "peoplesync-emp-learning-development", label: "My Learning & Development", link: "/peoplesync/emp-learning-development", permissionTypeId: [] },
                        { id: "peoplesync-emp-goal-settings", label: "My Goal Setting", link: "/peoplesync/emp-goal-settings", permissionTypeId: [] },
                        { id: "peoplesync-my-attendance", label: "My Attendance", link: "/peoplesync/my-attendance", permissionTypeId: [] },
                        { id: "peoplesync-my-leave-summary", label: "My Leave Summary", link: "/peoplesync/my-leave-summary", permissionTypeId: [] },
                    ],
                },
                {
                    id: "peoplesync-workforce", label: "Workforce Development", icon: "ri-graduation-cap-fill",
                    link: "/#", parentId: "peoplesync", isChildItem: true,
                    stateVariables: isPeopleSyncWorkforce,
                    click: function (e) { e.preventDefault(); setIsPeopleSyncWorkforce(!isPeopleSyncWorkforce); setIscurrentState("PeopleSyncWorkforce"); },
                    childItems: [
                        { id: "peoplesync-learning-development", label: "Learning & Development", link: "/peoplesync/learning-development", permissionTypeId: [] },
                        { id: "peoplesync-goal-settings", label: "Goal Setting", link: "/peoplesync/goal-settings", permissionTypeId: [] },
                        { id: "peoplesync-performance-evaluation", label: "Performance Evaluation", link: "/peoplesync/performance-evaluation", permissionTypeId: [] },
                        { id: "peoplesync-reward-recognition", label: "Rewards & Recognition", link: "/peoplesync/reward-recognition", permissionTypeId: [] },
                    ],
                },
                {
                    id: "peoplesync-timekeeping", label: "Time & Leave", icon: "ri-calendar-check-fill",
                    link: "/#", parentId: "peoplesync", isChildItem: true,
                    stateVariables: isPeopleSyncTimekeeping,
                    click: function (e) { e.preventDefault(); setIsPeopleSyncTimekeeping(!isPeopleSyncTimekeeping); setIscurrentState("PeopleSyncTimekeeping"); },
                    childItems: [
                        { id: "peoplesync-employee-attendance", label: "Employee Attendance", link: "/peoplesync/employee-attendance", permissionTypeId: [] },
                        { id: "peoplesync-employee-leave-summary", label: "Leave Summary", link: "/peoplesync/leave-summary", permissionTypeId: [] },
                    ],
                },
                {
                    id: "peoplesync-transactions", label: "Transactions", icon: "ri-file-transfer-fill",
                    link: "/peoplesync/transactions", parentId: "peoplesync", permissionTypeId: [],
                },
                {
                    id: "peoplesync-reports", label: "Reports", icon: "ri-article-line",
                    link: "/peoplesync/reports", parentId: "peoplesync", permissionTypeId: [],
                },
                {
                    id: "peoplesync-settings", label: "Settings", icon: "ri-settings-2-fill",
                    link: "/peoplesync/staticdata", parentId: "peoplesync",
                    permissionTypeId: [
                    ],
                },
            ],
        },
    ];
}